var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barrages-drop"},[_c('vue-baberrage',{staticStyle:{"padding-top":"10px"},attrs:{"isShow":_vm.barrageIsShow,"barrageList":_vm.barrageList,"throttleGap":_vm.throttleGap,"loop":_vm.barrageLoop,"lanesCount":_vm.lanesCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }